import React from "react";
import { createRoot } from "react-dom/client";
import { LandingApp } from "./landing/App";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/free-mode";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("landing-root");
  if (!el) return;
  createRoot(el).render(<LandingApp />);
});
